import React, { lazy } from 'react'

const LicenseAgreementPage = lazy(() => import('./LicenseAgreementPage'))

export { LicenseAgreementPage }
